<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>
          Add Alias
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pb-0">
        <p>
          {{$t('MonitoringFeatureAlias.aliasCanContainDataMsg')}} <br />
          Aliases can assign metadata to imported data based on the alias type selected below.
        </p>
        <p class="mb-0">
          <strong>Alias Type</strong> of new alias:
        </p>
        <v-radio-group hide-details class="mt-2" v-model="mergeOutcome">
          <v-radio color="info" class="primary--text" label="Regular alias" :value="MERGE_OUTCOMES.becomeAlias" />
          <v-radio color="info" label="QA/QC alias" :value="MERGE_OUTCOMES.becomeQAQCAlias" />
          <v-radio color="info" label="Depth/Height alias" :value="MERGE_OUTCOMES.becomeDepthHeightAlias" />
        </v-radio-group>
      </v-card-text>

      <AddAliasForm v-if="dialog" ref="form" :givenStation="currentDiscreteStation" :nonPrimaryGivenStationAliases="nonPrimaryAliases" :isQaQc="mergeParameters.isQaQc" :isDepthHeightDatum="mergeParameters.isDepthHeightDatum" :valid.sync="formIsValid" @close="close()" />

      <v-card-actions>
        <v-spacer />
        <v-btn color="success" @click="submit()" :loading="loading" :disabled="!formIsValid">
          <v-icon class="mr-1">done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn outline color="secondary" @click="close()">{{ $t('Button.Close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import AddAliasForm from './AddAliasForm'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const MERGE_OUTCOMES = {
    becomeAlias: 'alias',
    becomeQAQCAlias: 'qaqc',
    becomeDepthHeightAlias: 'depthHeight',
  }

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const featureDataSources = createNamespacedHelpers('datasource')

  export default {
    components: {
      AddAliasForm,
    },
    props: {},
    data() {
      return {
        MERGE_OUTCOMES,
        mergeOutcome: MERGE_OUTCOMES.becomeAlias,
        dialog: false,
        loading: false,
        formIsValid: true,
      }
    },
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceIndexByType', 'currentFeatureDataSourceData']),
      ...featureDataSources.mapGetters(['dataSourceIndex']),
      discreteDataSource() {
        return this.currentFeatureDataSourceIndexByType[SOURCE_TYPES.discreteEnvirodata]
      },
      discreteStation() {
        if (!this.discreteDataSource) return []
        return this.dataSourceIndex[SOURCE_TYPES.discreteEnvirodata][this.discreteDataSource.SourceId]
      },
      aliases() {
        return this.discreteStation && this.discreteStation.Synonyms || []
      },
      nonPrimaryAliases() {
        return this.aliases.filter(alias => !alias.IsPrimary)
      },
      discreteStationsIndex() {
        return this.dataSourceIndex[SOURCE_TYPES.discreteEnvirodata] || []
      },
      currentDiscreteStation() {
        return this.discreteStationsIndex[this.discreteDataSource.SourceId]
      },
      mergeParameters() {
        if (this.mergeOutcome == MERGE_OUTCOMES.becomeAlias) {
          return {
            isDepthHeightDatum: false,
            isQaQc: false,
          }
        } else if (this.mergeOutcome == MERGE_OUTCOMES.becomeQAQCAlias) {
          return {
            isDepthHeightDatum: false,
            isQaQc: true,
          }
        } else if (this.mergeOutcome == MERGE_OUTCOMES.becomeDepthHeightAlias) {
          return {
            isDepthHeightDatum: true,
            IsQaQc: false,
          }
        }

        throw 'Merge outcome not defined'
      },
    },
    methods: {
      show() {
        this.dialog = true
      },
      close() {
        this.dialog = false
      },
      async submit() {
        this.loading = true

        try {
          await this.$refs.form.submit()
        } catch (error) {
          console.error(error)
        }

        this.loading = false
      },
    },
  }
</script>